import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';

import { FormularioOrtodontia } from '../../base/vo/formulario-ortodontia';
import { FaseTratamentoEnum } from '../../base/enum/fase-tratamento';

const FASE_INICIAL = { preventiva: 'btn', interceptativa: 'btn', corretiva: 'btn', ortopedica: 'btn'};

@Component({
    selector: 'app-prorrogacao-ortodontia',
    templateUrl: './prorrogacao-ortodontia.component.html',
    styleUrls: ['./prorrogacao-ortodontia.component.css']
})
export class ProrrogacaoOrtodontiaComponent implements OnInit {

    @Input() formularioOrtodontia: FormularioOrtodontia;
    @Output() btnProximoEvent = new EventEmitter();
    
    //Para app anexar
    @Input() codigoBeneficiario: string;
    @Input() codigoPrestadorExecutante: string;
    @Input() anexos: any;
	
	public fase: any = this.criarCopiaObjeto(FASE_INICIAL);

    constructor() { }

    ngOnInit() { }
	
	private getStringFase(fase: string){
	    return this.fase[fase];
	}
	
	public isBtnDisabled(){
        if(!this.formularioOrtodontia.justificativaProrrogacao || !this.formularioOrtodontia.alteracoesOcorridas || !this.isValidAnexos()) {
        	return true;
        }
        return false;
    }
	
	public proximo(){
        this.btnProximoEvent.emit();
    }
    
    public selecionaFase(fase: string): void {
        this.fase = this.criarCopiaObjeto(FASE_INICIAL);
        this.fase[fase] = 'btn btn-primary';
        this.formularioOrtodontia.faseDoTratamento = FaseTratamentoEnum[fase.toUpperCase()] ;
    }
    
    private criarCopiaObjeto(obj: {}): {} {
        return Object.assign({}, obj);
    }
    
    private isValidAnexos():boolean {
	  	//Checar anexos tratamento
		if(!this.isValidAnexosIncluidos(this.anexos)) {
			return false;
		}
		
		return true;
	}
    
    private isValidAnexosIncluidos(anexos):boolean {
		if(anexos && anexos.length>0) {
			for (let i = 0; i < anexos.length; i++) {
				if(anexos[i].isInvalidTipo || anexos[i].isInvalidSituacao) {
					return false;
				}
	        }
		}
		return true;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/ortodontia/prorrogacao-ortodontia/prorrogacao-ortodontia.component.ts